module.exports = __webpack_public_path__ + "img/20200723_174120.0c093a02.jpg";